const USER = "Mr Suricate";

class MrSuricateService {
    public static $inject: string[] = ["$cookies", "$location", "$log"];

    private user: string = USER;

    constructor(
        private $cookies: angular.cookies.ICookiesService,
        private $location: ng.ILocationService,
        private $log: ng.ILogService
    ) {}

    public hasAccess() {
        const user = this.$cookies.get("user");
        const host = this.$location.host();
        const validHostRegex = /atlas\.(dev)|(int)|(pp)*-indb\.io/;
        const validHost = validHostRegex.test(host);
        const validUser = user === this.user;

        if (!user) {
            return;
        }

        this.$log.info(`Trying to set a bypass access for ${this.user}`, {
            host,
            user,
            validHost,
            validUser
        });

        return validHost && validUser;
    }
}

angular
    .module("thor.core.mr-suricate.service", [])
    .service("mrSuricateService", MrSuricateService);
